const recaptchaKey = '6LdNxfMUAAAAAHE6Ouh0cJxeYAwqHB37LURz6Ve8'
export { recaptchaKey }